import { createContext, useContext, useEffect, useState } from "react";
import { TRANSLATIONS, LANGUAGES } from "./translations";

const Ctx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const savedLanguage = localStorage.getItem("gidza_lang");
    return TRANSLATIONS[savedLanguage] ? savedLanguage : "id";
  });
  useEffect(() => { localStorage.setItem("gidza_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = (path) => {
    const parts = path.split(".");
    let node = TRANSLATIONS[lang] || TRANSLATIONS.id;
    for (const p of parts) { node = node?.[p]; if (node === undefined) break; }
    if (node === undefined) {
      // fallback to id
      let f = TRANSLATIONS.id; for (const p of parts) f = f?.[p];
      return f ?? path;
    }
    return node;
  };
  return <Ctx.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>{children}</Ctx.Provider>;
}

export const useI18n = () => useContext(Ctx);
